import { render } from "./chartXAxis.vue?vue&type=template&id=495d1458"
import script from "./chartXAxis.vue?vue&type=script&lang=js"
export * from "./chartXAxis.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__